import { defineComponent as _defineComponent } from 'vue'
import AboutBE from '@/AboutBE.json';
import AboutFE from '@/AboutFE.json';
import AttributionsList, {
  AttributionItem,
  License,
} from './common/attributionsList/AttributionsList.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

function getGithubLinkForFrontendAttribution(link: string): string {
  const index = link.indexOf('github.com');
  return link.substring(index);
}

function parseFrontendLicenses(license: string): License[] {
  return [
    {
      license,
      licenseUrl: getLicenseLinkForFrontendAttribution(license),
    },
  ];
}

function getLicenseLinkForFrontendAttribution(license: string): string {
  return `https://opensource.org/license/${license.trim().toLowerCase()}`;
}

const frontendAttributions = computed((): AttributionItem[] => {
  return AboutFE.map((x) => ({
    name: x.name,
    url: getGithubLinkForFrontendAttribution(x.link),
    version: x.installedVersion,
    authors: x.author !== '' ? [x.author] : [],
    licenses: parseFrontendLicenses(x.licenseType),
  }));
});

const backendAttributions = computed((): AttributionItem[] =>
  // PackageId: string;
  // PackageVersion: string;
  // PackageProjectUrl: string;
  // Authors: string[];
  // License: string;
  // LicenseUrl: string;
  AboutBE.map((x) => ({
    name: x.PackageId,
    version: x.PackageVersion,
    url: x.PackageProjectUrl,
    authors: x.Authors.split(', '),
    licenses:
      x.LicenseUrl !== ''
        ? [
            {
              license: x.License,
              licenseUrl: x.LicenseUrl,
            },
          ]
        : [],
  })),
);

const attributions = computed((): AttributionItem[] =>
  [...backendAttributions.value, ...frontendAttributions.value].sort((a, b) =>
    a.name.localeCompare(b.name),
  ),
);

return { __sfc: true,getGithubLinkForFrontendAttribution, parseFrontendLicenses, getLicenseLinkForFrontendAttribution, frontendAttributions, backendAttributions, attributions, AttributionsList }
}

})